import { setGeofenceAreas } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { GeofenceAreaModel, useListGeofenceAreasQuery } from '@casops/store/apis/geofenceAreasApi';

const useGeofenceAreaOptions = (): DropdownItemProps<string>[] => {
  const { data: geofenceAreas } = useListGeofenceAreasQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo(() => {
    return geofenceAreas
      ? geofenceAreas.map(({ id, name }: GeofenceAreaModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: name };
        })
      : [];
  }, [geofenceAreas]);
};

export const GeofenceAreasFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<string>
      filterName="geofenceAreas"
      label={label ?? t('Fields.Filters.GeofenceArea')}
      action={setGeofenceAreas}
      elementRef={elementRef}
      useItemsHook={useGeofenceAreaOptions}
    />
  );
};

export default GeofenceAreasFilter;
